export const normalizeMonitoringTaskType = (taskType?: string): string => {
  switch (taskType) {
    case "Divisão de Lote":
    case "BATCH_SPLIT":
      return "Dividir lote";
    default:
      return taskType ?? "";
  }
};
